export const onedoc = {
  methods: {
    getVersion: function () {
      return '1.0'
    },
    spaCompletedCallback: function (resultData) {
      if (resultData) {
        // console.log('spaCompletedCallback in oneWeb-Demo:\n\n' + JSON.stringify(resultData))
        $('#oneDocCompleted').val('true')
      }
    },
    spaSkippedCallback: function (customerData) {
      if (customerData) {
        // console.log('spaSkippedCallback in oneWeb-Demo:\n\n' + JSON.stringify(customerData))
        $('#oneDocCompleted').val('true')
      }
    },
    spaErrorCallback: function (errorData) {
      if (errorData) {
        // console.log('spaErrorCallback in oneWeb-Demo:\n\n' + JSON.stringify(errorData))
        $('#oneDocCompleted').val('true')
      }
    },
    setIframeHeight: function (height) {
      if (height > 200 && $('#docTemplateBlock').hasClass('ciam-page') === false) {
        $('.ciam-page').each(function () {
          this.style.display = 'none'
        })
        $('#docTemplateBlock').addClass('ciam-page')
        document.getElementById('docTemplateBlock').classList.toggle('fade')
        $('#oneDocLoaded').val('true')
      }
      $('#oneDoCSpa').height(height)
    },
    // add event listener which can also support for IE8+
    bindEvent: function (element, eventName, eventHandler) {
      if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false)
      } else if (element.attachEvent) {
        element.attachEvent('on' + eventName, eventHandler)
      }
    }
  }
}
// bind event to handle received and sent message
onedoc.methods.bindEvent(window, 'message', function (e) {
  // check received message
  if (e && e.data && e.data.indexOf) {
    const start = e.data.indexOf('(')
    const end = e.data.lastIndexOf(')')
    if (start === -1 || end === -1) {
      console.error('invalid message format')
    }
    const method = e.data.substring(0, start)
    const payload = e.data.substring(start + 1, end) !== '' ? JSON.parse(e.data.substring(start + 1, end)) : 0
    switch (method) {
      case 'spaCompletedCallback':
        onedoc.methods.spaCompletedCallback(payload)
        break
      case 'spaErrorCallback':
        onedoc.methods.spaErrorCallback(payload)
        break
      case 'spaSkippedCallback':
        onedoc.methods.spaSkippedCallback(payload)
        break
      case 'setIframeHeight':
        onedoc.methods.setIframeHeight(payload)
        break
      default:
        console.log('other method')
    }
  }
})
